// extracted by mini-css-extract-plugin
export default {"characterBoard":"dxOh9e","left":"NcO2Nw","border":"MffzGB","bg":"cdaegi","front":"jb3egh","right":"kN3tmX","boss":"ItCFyO","npc":"b0T4bu","active":"isHy9D"};